<script lang="ts">
    // TODO: rdar://78161351 (<ButtonAction> and <ClickAction> improvements)
    // TODO: rdar://92270447 (JMOTW: Refactor ButtonAction component to use Button component)
    import PlayIcon from '~assets/icons/play.svg';
    import ClickAction from '~/components/jet/action/ClickAction.svelte';
    import type { Action } from '~/jet/models';

    export let action: Action;
    export let title: string;
    export let disabled: boolean = false;
    export let styleOverride: {
        isPlay?: boolean;
        isPrimary?: boolean;
        isSecondary?: boolean;
        isPill?: boolean;
    } = {};

    $: kind = action.$kind;
    $: isPlayAction = styleOverride.isPlay ?? ['playAction'].includes(kind);
    $: isPrimary =
        styleOverride.isPrimary ?? (!styleOverride.isSecondary && isPlayAction);
    $: isSecondary = styleOverride.isSecondary;
    $: isPill = styleOverride.isPill;
</script>

<div
    data-testid="button-action"
    class="button"
    class:primary={isPrimary}
    class:secondary={isSecondary}
    class:pill={isPill}
>
    <ClickAction {action} {disabled}>
        {#if isPlayAction}
            <span class="icon" data-testid="play-icon"><PlayIcon /></span>
        {/if}
        {title}
    </ClickAction>
</div>

<style lang="scss">
    @use '@amp/web-shared-styles/app/core/globalvars' as *;

    .button {
        width: 100%;

        @media (--medium) {
            width: auto;
        }

        /* TODO: rdar://78161351: this is kind of messy */
        :global(button) {
            width: 100%;
            height: 36px;
            font: var(--body-emphasized);
            display: flex;
            align-items: center;
            justify-content: center;

            @media (--medium) {
                width: auto;
                height: $action-button-size;
            }
        }

        &.primary :global(button) {
            color: white;
            background-color: var(--keyColorBG);
            border-radius: $global-border-radius-medium;
            padding: 0 10px;
        }

        &.secondary :global(button) {
            color: var(--keyColor);
            background-color: var(--systemQuinary);
            border-radius: $global-border-radius-medium;
            padding: 0 10px;
        }

        &.pill :global(button) {
            width: auto;
            height: 28px;
            padding-inline-start: 12px;
            padding-inline-end: 12px;
            background-color: var(--systemQuaternary);
            border-radius: 16px;
        }
    }

    .icon :global(svg) {
        /* TODO: rdar://78161351: size probably is incorrect */
        height: 12px;

        /* TODO: rdar://78161351: absolutely gnarly vertical positioning */
        position: relative;
        top: 1px;

        .primary & {
            fill: white;
        }
    }
</style>
